import type { SVGProps } from 'react';

const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="-951 532 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M-944.853 536.149a.5.5 0 0 0 0 .707l3.646 3.646-3.646 3.646a.5.5 0 0 0 .707.707l4-4a.498.498 0 0 0 0-.708l-4-4a.502.502 0 0 0-.707.002z"></path>
    </svg>
);

export default ArrowRight;
